import { FlexColumnAlignJustifyCenter } from "@/components/Flex";
import br from "@/styles/breakpoints.module.css";
import { themeColors } from "@/utils/themeColors";
import React from "react";
import LogoSlider from "../../../TeacherAITools/components/LogoSlider";
import StudentRelyOnKnowt from "../../LandingMainPage/components/StudentsRelyOnKnowt";
import { ReviewType } from "../../LandingMainPage/constants";
import { LandingHalfSection } from "../../components/styled/Containers";
import styles from "./medias/video-summarizer.module.css";

const DefaultHeader = ({
    title,
    subtitle,
    isForSchools,
}: { title?: string; subtitle?: string; isForSchools?: boolean }) => {
    const headerTitle = title ?? "Trusted by millions across the globe";

    return (
        <FlexColumnAlignJustifyCenter
            className={styles.feedbacksHeader}
            style={{
                textAlign: "center",
                overflow: isForSchools ? "visible" : "hidden",
                width: isForSchools ? "100%" : undefined,
            }}>
            {/* Desktop */}
            <div className={br.smDownDisplayNone}>
                <h2 className={"heading2"} style={{ marginBottom: "1.6rem" }}>
                    {headerTitle}
                </h2>
                <p className={"bodyXl"}>
                    {subtitle ?? "Our community of students and teachers trust Knowt to create and study on."}
                </p>

                {isForSchools && <LogoSlider />}
            </div>

            {/* Mobile */}
            <div className={br.smUpDisplayNone}>
                <p className={"bodyBold1"}>{headerTitle}</p>
                <p className={"body2"}>Our community of students and teachers trust Knowt to create and study on.</p>
            </div>
        </FlexColumnAlignJustifyCenter>
    );
};

const UsersFeedbacks = ({
    header,
    type,
    title,
    subtitle,
    isForSchools,
    fullHeight,
    isWithStats,
}: {
    header?: React.ReactNode;
    type: ReviewType;
    title?: string;
    subtitle?: string;
    isForSchools?: boolean;
    fullHeight?: boolean;
    isWithStats?: boolean;
}) => {
    return (
        <LandingHalfSection style={{ maxWidth: isForSchools ? "unset" : "120rem", textAlign: "center" }}>
            <h2 className="heading2" style={{ marginBottom: "1rem" }}>
                {title ?? "Trusted by millions"}
            </h2>
            <p className="bodyXl" style={{ marginBottom: "2.5rem" }}>
                {subtitle ?? "Everyone is relying on Knowt, and we never let them down."}
            </p>
            {isForSchools && <LogoSlider />}
            {/* TODO: Need refactor to remove the overwriting of the header */}
            <StudentRelyOnKnowt
                header={header || <DefaultHeader title={title} subtitle={subtitle} isForSchools={isForSchools} />}
                type={type}
                containerStyle={{
                    maxWidth: isForSchools ? "98rem" : "unset",
                    overflow: isForSchools ? "visible" : "hidden",
                    padding: isForSchools ? 0 : "unset",
                }}
                feedbacksListContainerStyle={styles.feedbacksListContainer}
                feedbackCardsStyle={{ backgroundColor: themeColors.neutralWhite }}
                fullHeight={fullHeight}
                isWithStats={isWithStats}
            />
        </LandingHalfSection>
    );
};

export default UsersFeedbacks;
